import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const UserAuthContext = createContext(null);

export function UserAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("furshala_user_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      localStorage.removeItem("furshala_user_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If we're returning from an OAuth callback, skip the /me check.
    // AuthCallback will exchange session_id and set the token first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginWithSessionId = async (sessionId) => {
    const r = await api.post("/auth/session", { session_id: sessionId });
    localStorage.setItem("furshala_user_token", r.data.session_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* non-fatal */ }
    localStorage.removeItem("furshala_user_token");
    setUser(null);
  };

  return (
    <UserAuthContext.Provider value={{ user, loading, loginWithSessionId, logout, refresh: checkAuth }}>
      {children}
    </UserAuthContext.Provider>
  );
}

export const useUserAuth = () => useContext(UserAuthContext);
